import { render, staticRenderFns } from "./InfoCardTrainings.vue?vue&type=template&id=2c5ce37a&scoped=true&"
import script from "./InfoCardTrainings.vue?vue&type=script&lang=js&"
export * from "./InfoCardTrainings.vue?vue&type=script&lang=js&"
import style0 from "./InfoCardTrainings.vue?vue&type=style&index=0&id=2c5ce37a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5ce37a",
  null
  
)

export default component.exports